import { Suspense } from 'react'
import { App as AntApp } from 'antd'
import { Router } from './routes'
import Loading from './components/Loading'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  return (
    <AntApp>
      <ErrorBoundary>
        <Suspense fallback={<Loading fullScreen />}>
          <Router />
        </Suspense>
      </ErrorBoundary>
    </AntApp>
  )
}

export default App
